window.addEventListener('load', () => {
  const scrollContainer = document.querySelector('.page-wrapper');
  const hero = document.querySelector('.hero__container');
  const img = hero?.querySelector('img.hero__media');
  
  if (!scrollContainer || !hero || !img) return;

  hero.style.overflow = 'hidden';

  const speed = -0.1;

  function updateParallax() {
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;

    const offset = rect.top * speed;
    img.style.transform = `translateY(${offset}px)`;
  }

  scrollContainer.addEventListener('scroll', updateParallax, { passive: true });
  updateParallax();
});